import React, { useEffect, useState, useRef } from 'react';
import './HomePage.css';
import girlPic from '../Images/Girl-pic.png';
import appImage from '../Images/image.png';
import banner1 from '../Images/banner1.png';
import banner2 from '../Images/banner2.png';
import banner3 from '../Images/banner3.png';
import app_store from '../Images/app_store.webp';
import play_store from '../Images/play_store.webp';
import Spoken_english from '../Images/spoken-english.svg';
import VedicMath from '../Images/math.svg';
import CodingClass from '../Images/coding-classes.svg';
import Abacus from '../Images/abacus.svg';
import demoVideo1 from '../Images/DemoVideo.mp4'; 
import {Helmet} from "react-helmet";

const HomePage = () => {
  // Slideshow state to manage the current image index
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [banner1, banner2, banner3];
  const [activeStep, setActiveStep] = useState(1);
  const videoRef = useRef(null); 

  const steps = [
    {
      id: 1,
      title: "Purchase the Batch",
      content1: "👉 Select your desired class.",
      content2: "👉 Click the Buy Now button.",
      content3: "👉 Complete the payment process",
      video: demoVideo1,
    },
    {
      id: 2,
      title: "Post-Purchase Communication",
      content:
        "👉 Our team will reach out to the parent and student to facilitate the setup of live classes and provide study materials. Communication will be conducted through call and WhatsApp.",
      video: demoVideo1,
    },
    {
      id: 3,
      title: "WhatsApp Group Setup",
      content:
        "👉 All live class updates, study materials, and other communications will be shared via a dedicated WhatsApp group. You will be added to the group after completing the payment.",
      video: demoVideo1,
    },
    {
      id: 4,
      title: "Learning Sessions",
      content:
        "👉 Classes will be conducted live by tutors via Zoom. The live class link will be shared in the WhatsApp group.",
      video: demoVideo1,
    },
  ];

  const handleStepClick = (id) => {
    setActiveStep(id);
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);

    return () => clearInterval(intervalId);
  }, [images.length]);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  return (
    <div className="container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Otter Tutor - Your Trusted Learning Partner</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    <div className="header-section">
    <div className="slideshow">
  <div
    className="slideshow-images"
    style={{ transform: `translateX(-${currentImageIndex * 100}%)`, display: 'flex' }}
  >
    {images.map((image, index) => (
      <div key={index} style={{ flex: '0 0 100%' }}>
        {index === 1 || index === 2 ? (
          <a href="/batches">
            <img
              src={image}
              alt={`Banner ${index + 1}`}
              className="slideshow-image"
              style={{ width: '100%', height: 'auto', display: 'block' }}
              loading="lazy"
            />
          </a>
        ) : (
          <img
            src={image}
            alt={`Banner ${index + 1}`}
            className="slideshow-image"
            style={{ width: '100%', height: 'auto', display: 'block' }}
            loading="lazy"
          />
        )}
      </div>
    ))}
  </div>
  {/* Dots as Indicators */}
  <div className="dots">
    {images.map((_, index) => (
      <span
        key={index}
        className={`dot ${index === currentImageIndex ? 'active' : ''}`}
        onClick={() => handleDotClick(index)}
      ></span>
    ))}
  </div>
</div>

   </div>
      
      {/* Popular Courses Section */}
      <div className="popular-courses">
        <h2 className="popular-courses-title">Education <span className='highlight'>Pathways</span></h2>
        <div className="course-card-container">
  <a href="/Final-Orbit" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#F5D9FF", fontSize: "20px" }}>
      🎓 <span>12</span>
    </div>
  </a>
  <a href="/Vigyaan-ki-Udaan" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#FFF0CC", fontSize: "20px" }}>
      📖 <span>11</span>
    </div>
  </a>
  <a href="/Dasvi-ke-Dangal" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#DFFFE0", fontSize: "20px" }}>
      🧮 <span>10</span>
    </div>
  </a>
  <a href="/Nauvi-ke-Sikandar" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#FFD9F5", fontSize: "20px" }}>
      🧪 <span>9</span>
    </div>
  </a>
  <a href="/Ashtveer" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#FFE7D7", fontSize: "20px" }}>
      🌍 <span>8</span>
    </div>
  </a>
  <a href="/Chhattrapati" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#DFE5FF", fontSize: "20px" }}>
      📚 <span>7</span>
    </div>
  </a>
  <a href="/Pratham-Prayas" className="course-card-link">
    <div className="course-card" style={{ backgroundColor: "#DFE5FF", fontSize: "20px" }}>
      ✏️ <span>6</span>
    </div>
  </a>
</div>
      </div>
      <div className="kids-courses-container">
      <h2 className='kids-title'>
        Courses for <span className="highlight">kids</span>
      </h2>
      <div className="content">
        <div className="kids-course-cards">
          <div className="kids-course-card spoken-english">
          <img src={Spoken_english} loading="lazy" alt="Spoken English Icon" className="kids-course-icon" />
            
            <h3>Class 4 - 8</h3>
            <h2>Spoken English Program</h2>
            <p>Master fluency in English speaking</p>
            <a href='/bolo-bindass' className='course-card-link'>
            <button className="explore-button">Explore</button>
            </a>
            </div>
          <div className="kids-course-card learn-english">
          <img src={Abacus} loading="lazy" alt="Spoken English Icon" className="course-icon" />
            <h3>Class 1 - 6</h3>
            <h2>Learn Abacus</h2>
            <p>Personalized <b>Abacus</b> Learning</p>
            <a href='brain-o-meter' className='course-card-link'>
            <button className="explore-button">Explore</button>
            </a>
            </div>
          <div className="kids-course-card learn-math">
          <img src={VedicMath} loading="lazy" alt="Spoken English Icon" className="course-icon" />
            <h3>Class 1 to 6</h3>
            <h2>Vedic Math</h2>
            <p>Turn your child into a Math wizard</p>
            <a href='/gurukul-ganit' className='course-card-link'>
            <button className="explore-button">Explore</button></a>
            </div>
          <div className="kids-course-card coding-classes">
          <img src={CodingClass} loading="lazy" alt="Spoken English Icon" className="course-icon" />
            <h3>Class 6 - 10</h3>
            <h2>Coding Class</h2>
            <p>Learn to build apps and games, be future ready</p>
            <a href='tech-gurukul' className='course-card-link'>
            <button className="explore-button">Explore</button>
            </a>
            </div>
        </div>
        <div className="image-section">
        <img
          src={girlPic}
          alt="Girl holding notebook"
          className="girl-image"
        />
      </div>
      </div>
    </div>
    <div className="how-it-works">
        <h2>How to learn with <span className="highlight">Otter Tutors!</span></h2>
        <div className="content-container">
          <div className="steps-container">
            {steps.map((step, index) => (
              <div key={step.id} className="step-item">
                {/* Step Indicator */}
                <div
                  className={`step-indicator ${activeStep >= step.id ? "active-indicator" : ""}`}
                  onClick={() => handleStepClick(step.id)}
                >
                  🟠
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`step-line ${activeStep > step.id ? "active-line" : ""}`}
                  ></div>
                )}
              </div>
            ))}
          </div>

          {/* Step Content and Video */}
          <div className="main-content">
            <div className="step-details">
              {steps.map((step) => (
                <div key={step.id} className="step-description">
                  <h3
                    className={`step-title ${activeStep === step.id ? "active-title" : ""}`}
                    onClick={() => handleStepClick(step.id)}
                  >
                    {step.title}
                  </h3>
                  {activeStep === step.id && (
                    <>
                      <p>{step.content}</p>
                      <p>{step.content1}</p>
                      <p>{step.content2}</p>
                      <p>{step.content3}</p>
                    </>
                  )}
                </div>
              ))}
            </div>

            {/* Video Container */}
            {activeStep && (
              <div className="video-container">
                <video
                  ref={videoRef}
                  src={steps.find((step) => step.id === activeStep)?.video || ""}
                  autoPlay
                  muted
                  playsInline
                  className="demo-video"
                ></video>
              </div>
            )}
          </div>
        </div>
      </div>
    {/* New Why Otter Tutors Section */}
    <div className="why-otter-tutors">
        <h2 className="why-title">Why Otter Tutors</h2>
        <div className="why-points">
          <div className="point">
            <h3>Personalized Learning Experience</h3>
            <p>We tailor our tutoring approach to meet the unique needs of each student, ensuring that their individual strengths and weaknesses are addressed effectively.</p>
          </div>
          <div className="point">
            <h3>Qualified and Experienced Tutors</h3>
            <p>Our team consists of highly qualified tutors who are not only experts in their subjects but also passionate about teaching and helping students succeed.</p>
          </div>
          <div className="point">
            <h3>Comprehensive Coverage</h3>
            <p>We cater to a wide range of educational levels, from K1 to K12, as well as preparing students for competitive exams like IIT JEE and NEET.</p>
          </div>
          <div className="point">
            <h3>Engaging and Interactive Learning</h3>
            <p>Our innovative teaching methods include gamified learning experiences and interactive sessions that keep students engaged and motivated.</p>
          </div>
        </div>
      </div>
      {/* Get the Learning App Section */}
      <div className="get-learning-app">
        <div className="app-info">
          <h2>Get the learning app</h2>
          <p>We’re soon available on Android devices and platforms. Study from anywhere at your convenience.</p>
          <div className="app-buttons">
            <img src={app_store} loading="lazy" alt="Download on the App Store" />
            <img src={play_store} loading="lazy" alt="Get it on Google Play" />
          </div>
        </div>
        <div className="app-image">
          <img src={appImage} loading="lazy" alt="Otter-Tutors app preview" />
        </div>
      </div>
      
    </div>
  );
};

export default HomePage;
